import { render, staticRenderFns } from "./content-cell.vue?vue&type=template&id=81dd0554"
import script from "./content-cell.vue?vue&type=script&lang=js"
export * from "./content-cell.vue?vue&type=script&lang=js"
import style0 from "./content-cell.vue?vue&type=style&index=0&id=81dd0554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/tariff/title-type/content-cell.vue
// module id = null
// module chunks = 